if (typeof BackButton !== 'function') {
	class BackButton extends HTMLElement {
		constructor() {
			super();

			this.init();
		}

		init() {
			if (this) {
				this.addEventListener('click', () => {
					if (window.history && window.history.length > 1) {
						window.history.back();
					} else {
						window.location.href = '/';
					}
				});
			}
		}
	}

	if (!customElements.get('back-button')) {
		customElements.define('back-button', BackButton);
	}
}
